import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import sad from "../../assets/images/other-images/sad.png";

const Error404 = () => {
  return (
    <>
      <div className="page-wrapper">
        {/* <!-- error-404 start--> */}
        <div className="error-wrapper">
          <div className="container">
            <img className="img-100" src={sad} alt="" />
            <div className="error-heading">
              <h2 className="headline font-danger">404</h2>
            </div>
            <div className="col-md-8 offset-md-2">
              <p className="sub-content">La pagina a la que intenta ingresar no existe. Esto podria deberse a un error o a que haya sido removida.</p>
            </div>
            <div>
              <Link to="/login" className="btn btn-danger-gradien">
                Volver al inicio
              </Link>
            </div>
          </div>
        </div>
        {/* <!-- error-404 end--> */}
      </div>
    </>
  );
};

export default Error404;
